module.exports = __webpack_public_path__ + "img/forgot-password.1c4591fa.svg";